module.exports = __webpack_public_path__ + "img/fant-farm-thumb.5341e6e2.jpg";